import { createSlice } from '@reduxjs/toolkit';
import { io } from 'socket.io-client';
import { SOCKET_URL } from '../constants/Constants';

const initialState = {
  socket: null,
  isConnected: false,
  pendingOrInProgress: false, // flag to track pending or in progress invoices
};

const socketConfigSlice = createSlice({
  name: 'socket',
  initialState,
  reducers: {
    connectSocket: (state, action) => {
      const userId = action.payload;
      const socket = io(`${SOCKET_URL}`, { transports: ['websocket'] });
      // Add a listener for the `connect` event
      socket.on('connect', () => {
        socket.emit('newConnection', userId); // Emit `newConnection` event with userId
      });

      return {
        ...state,
        socket,
        isConnected: true,
      };
    },
    disconnectSocket: (state) => {
      if (state.socket) {
        state.socket.emit('disconnectRequest', 'disconnect socket');
        return {
          ...state,
          socket: null,
          isConnected: false,
        };
      }
    },
    setPendingOrInProgress: (state, action) => ({
      ...state,
      pendingOrInProgress: action.payload,
    }),
    emitEvent: (state, action) => {
      const { event, data } = action.payload;
      if (state.socket) {
        state.socket.emit(event, data);
      }
      return state;
    },
    onEvent: (state, action) => {
      const { event, callback } = action.payload;
      if (state.socket) {
        state.socket.on(event, callback);
      }
      return state;
    },
  },
});

export const {
  connectSocket,
  disconnectSocket,
  emitEvent,
  onEvent,
  setPendingOrInProgress,
} = socketConfigSlice.actions;
export default socketConfigSlice.reducer;
